import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { EASE } from "@/lib/motion";
import { TESTIMONIALS } from "@/data/content";

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const active = TESTIMONIALS[index];

  const go = (dir) => {
    setIndex((prev) => (prev + dir + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-stone/40 py-28 md:py-44 scroll-mt-24"
    >
      <div className="mx-auto max-w-[1200px] px-6 md:px-10 text-center">
        <Reveal>
          <p className="kicker text-forest mb-10">In their words</p>
        </Reveal>

        <Quote size={44} strokeWidth={1} className="mx-auto text-gold mb-8" />

        <div className="min-h-[220px] md:min-h-[240px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={index}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.7, ease: EASE }}
              data-testid="testimonial-quote"
              className="max-w-3xl mx-auto"
            >
              <p className="font-serif font-light italic text-charcoal text-2xl md:text-4xl leading-[1.3] tracking-tight text-balance">
                “{active.quote}”
              </p>
              <footer className="mt-10">
                <p className="font-serif text-xl text-forest">{active.name}</p>
                <p className="kicker text-charcoal/50 mt-2 text-[0.6rem]">{active.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-6">
          <button
            onClick={() => go(-1)}
            aria-label="Previous testimonial"
            data-testid="testimonial-prev"
            className="h-12 w-12 flex items-center justify-center border border-stone text-forest transition-colors duration-400 hover:bg-forest hover:text-ivory hover:border-forest"
          >
            <ArrowLeft size={18} strokeWidth={1.4} />
          </button>
          <div className="flex items-center gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                aria-label={`Go to testimonial ${i + 1}`}
                className={`h-1.5 rounded-full transition-all duration-500 ${
                  i === index ? "w-8 bg-forest" : "w-1.5 bg-charcoal/25"
                }`}
              />
            ))}
          </div>
          <button
            onClick={() => go(1)}
            aria-label="Next testimonial"
            data-testid="testimonial-next"
            className="h-12 w-12 flex items-center justify-center border border-stone text-forest transition-colors duration-400 hover:bg-forest hover:text-ivory hover:border-forest"
          >
            <ArrowRight size={18} strokeWidth={1.4} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
